module.exports = __webpack_public_path__ + "img/mission-diversity-board-face-7.jpg?fa8237a8631d94d51cf4fce68b8ffc88";